module.exports = __webpack_public_path__ + "static/lightning-card-wrapped-c3e592fd382f16d110ae86a761ad6017.png";